import React from 'react'
import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";
import { MentionExtension } from "@tiptap/extension-mention";

const {
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Subscript,
    Superscript,
    ForeColor,
    BackColor,
    CleanFormatting,
    AlignLeft,
    AlignCenter,
    AlignRight,
    AlignJustify,
    Indent,
    Outdent,
    OrderedList,
    UnorderedList,
    NumberedList,
    BulletedList,
    Undo,
    Redo,
    FontSize,
    FontName,
    FormatBlock,
    Link,
    Unlink,
    InsertImage,
    ViewHtml,
    InsertTable,
    InsertFile,
    SelectAll,
    Print,
    Pdf,
    TableProperties,
    TableCellProperties,
    AddRowBefore,
    AddRowAfter,
    AddColumnBefore,
    AddColumnAfter,
    DeleteRow,
    DeleteColumn,
    DeleteTable,
    MergeCells,
    SplitCell
} = EditorTools;


function AddMiniProjectEditor() {
    return (
        <>
            <Editor
                tools={[
                    [Bold, Italic, Underline, Strikethrough],
                    [Subscript, Superscript],
                    [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                    [Indent, Outdent],
                    [OrderedList, UnorderedList],
                    [NumberedList, BulletedList],
                    [SelectAll],
                    [Undo, Redo],
                    [Link, Unlink, InsertImage],
                    [InsertTable, InsertFile],
                    [Pdf, Print],
                    [TableProperties, TableCellProperties],
                ]}
                contentStyle={{ height: 150, fontFamily: '"Manrope", sans-serif' }}
                className='custom_editor__'
            />
        </>
    )
}

export default AddMiniProjectEditor


// import React, { useState, useRef, useEffect } from 'react';
// import { Editor, EditorTools, EditorUtils } from "@progress/kendo-react-editor";

// const {
//     Bold, Italic, Underline, AlignLeft, AlignCenter, AlignRight, Undo, Redo
// } = EditorTools;

// // Dummy user data for mentions
// const users = [
//     { id: 1, name: "John Doe" },
//     { id: 2, name: "Jane Smith" },
//     { id: 3, name: "Alice Brown" },
// ];

// const AddProjectEditor = () => {
//     const editorRef = useRef(null);
//     const [mentionList, setMentionList] = useState([]);
//     const [showMention, setShowMention] = useState(false);
//     const [mentionPosition, setMentionPosition] = useState({ top: 0, left: 0 });

//     useEffect(() => {
//         if (editorRef.current) {
//             console.log("Editor Loaded Successfully!");
//         }
//     }, []);

//     const handleEditorChange = (event) => {
//         if (!editorRef.current) return;

//         const content = EditorUtils.getHtml(event.html);

//         // Detect "@" and show mention list
//         if (content.endsWith("@")) {
//             setMentionList(users);
//             setShowMention(true);
//             setMentionPosition({ top: 50, left: 10 });
//         } else {
//             setShowMention(false);
//         }
//     };

//     const insertMention = (user) => {
//         if (!editorRef.current || !editorRef.current.view) {
//             console.error("Editor is not initialized yet!");
//             return;
//         }

//         const editor = editorRef.current.view;

//         // Ensure editor content is available before inserting
//         setTimeout(() => {
//             const currentContent = EditorUtils.getHtml(editor) || "";
//             const mentionHtml = `<span class="mention">@${user.name}</span>&nbsp;`;
//             EditorUtils.setHtml(editor, currentContent + mentionHtml);
//         }, 0);

//         setShowMention(false);
//     };

//     return (
//         <div style={{ position: "relative" }}>
//             <Editor
//                 ref={editorRef}
//                 tools={[
//                     [Bold, Italic, Underline],
//                     [AlignLeft, AlignCenter, AlignRight],
//                     [Undo, Redo]
//                 ]}
//                 contentStyle={{ height: 150, fontFamily: '"Manrope", sans-serif' }}
//                 className='custom_editor__'
//                 //onMount={() => console.log("Editor is mounted")}
//                 //onChange={handleEditorChange}
//             />

//             {/* Mention Dropdown */}
//             {showMention && (
//                 <ul className="mention-dropdown" style={{ top: mentionPosition.top, left: mentionPosition.left }}>
//                     {mentionList.map(user => (
//                         <li key={user.id} onClick={() => insertMention(user)}>
//                             @{user.name}
//                         </li>
//                     ))}
//                 </ul>
//             )}
//         </div>
//     );
// };

// export default AddProjectEditor;


